/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationTypeDto = {
    DevelopmentPlanInitialized: 'DEVELOPMENT_PLAN_INITIALIZED',
    DevelopmentPlanToSupervisorAcceptanceRequested: 'DEVELOPMENT_PLAN_TO_SUPERVISOR_ACCEPTANCE_REQUESTED',
    DevelopmentPlanSupervisorAccepted: 'DEVELOPMENT_PLAN_SUPERVISOR_ACCEPTED',
    DevelopmentPlanSupervisorRejected: 'DEVELOPMENT_PLAN_SUPERVISOR_REJECTED',
    DevelopmentPlanRequired: 'DEVELOPMENT_PLAN_REQUIRED',
    DevelopmentStepOverdue: 'DEVELOPMENT_STEP_OVERDUE',
    DevelopmentPlanInitiationRequired: 'DEVELOPMENT_PLAN_INITIATION_REQUIRED',
    SurveyAssigned: 'SURVEY_ASSIGNED',
    ExamParticipantAdded: 'EXAM_PARTICIPANT_ADDED',
    ExamDayStarted: 'EXAM_DAY_STARTED',
    IndividualExamStarted: 'INDIVIDUAL_EXAM_STARTED',
    EmployeeBirthdayUpcoming: 'EMPLOYEE_BIRTHDAY_UPCOMING',
    EmployeeBirthdayToday: 'EMPLOYEE_BIRTHDAY_TODAY',
    EmployeeBirthdayAfter: 'EMPLOYEE_BIRTHDAY_AFTER'
} as const;

export type NotificationTypeDto = typeof NotificationTypeDto[keyof typeof NotificationTypeDto];



